// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  background-color: #ffffff;
  min-height: 100vh;
  width: "100%";
  font-family: myfont;
  padding-top: 60px;
  padding-bottom: 40px;
}

.global-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  background-color: #ffffff;
}

.global-top-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #ffffff;
  margin-top: 2%;
  width: 30%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}
.btn-default-style {
  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;
  border: 1px solid #0068b3 !important;
  color: #ffcc00 !important;
}
.flex-for-center {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.App-link {
  color: #61dafb;
}

.login-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}
.login-desc {
  text-align: center;
  align-items: center;
  padding:0px 20px;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.required-asterisk{
  color: red !important;
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,mEAAmE;EACnE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".App {\n  background-color: #ffffff;\n  min-height: 100vh;\n  width: \"100%\";\n  font-family: myfont;\n  padding-top: 60px;\n  padding-bottom: 40px;\n}\n\n.global-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 80vh;\n  background-color: #ffffff;\n}\n\n.global-top-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #ffffff;\n  margin-top: 2%;\n  width: 30%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n.btn-default-style {\n  box-shadow: 9px 9px 16px #919a9c, -9px -9px 16px #ffffff !important;\n  border: 1px solid #0068b3 !important;\n  color: #ffcc00 !important;\n}\n.flex-for-center {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n}\n.App-link {\n  color: #61dafb;\n}\n\n.login-btn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 90vh;\n}\n.login-desc {\n  text-align: center;\n  align-items: center;\n  padding:0px 20px;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n.required-asterisk{\n  color: red !important;\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
